// @ts-check
import { h } from "./ui/dom.js";
import { field } from "./ui/field.js";

/** Render only the declared half of an account: public settings or vault credentials. */
export function createAccountFields(fields, secrets, values = {}) {
  const inputs = fields
    .filter((item) => (item.type === "secret") === secrets)
    .map((item) => {
      const control =
        item.type === "choice"
          ? h(
              "select",
              { class: "ui-select", required: item.required },
              h("option", { value: "", text: "Choose an option" }),
              ...item.choices.map((value) =>
                h("option", { value, text: value }),
              ),
            )
          : h("input", {
              class: "ui-input",
              type: secrets
                ? "password"
                : item.type === "https-url"
                  ? "url"
                  : "text",
              required: item.required,
              maxLength: item.type === "https-url" ? 2048 : 8192,
              autocomplete: "off",
              spellcheck: false,
            });
      if (!secrets) control.value = values[item.key] || "";
      return { item, control };
    });
  return {
    element: h(
      "div",
      { class: "ui-section__stack" },
      ...inputs.map(({ item, control }) =>
        field({
          label: item.label,
          control,
          hint: item.hint,
          optional: !item.required,
        }),
      ),
    ),
    read: () =>
      Object.fromEntries(
        inputs.flatMap(({ item, control }) => {
          const value = secrets ? control.value : control.value.trim();
          return value ? [[item.key, value]] : [];
        }),
      ),
    clear: () => {
      for (const { control } of inputs) control.value = "";
    },
  };
}
